import request from "../utils/request";

// ------------------------------------------------------------ 基础数据 ------------------------------------------------------------
// 获取线路费用服务费
// export function cwqr(headers) {
//   return request({
//     url: "/supplierNoticeRecord/cabinConfirmationMessage",
//     method: "post",
//     headers,
//   });
// }

// 获取线路费用服务费
export function Linefee(params,headers) {
  return request({
    url: "/SeaFclFreight/getLinefee",
    method: "get",
    params,
    headers,
  });
}


// 获取舱位详情
export function shippingDetail(params,headers) {
  return request({
    url: "/SeaFclFreight/shippingSpaceDetail",
    method: "get",
    params,
    headers,
  });
}

// 首页小喇叭
export function recentlyDynamics(headers) {
  return request({
    url: "/userNoticeRecord/recentlyDynamics",
    method: "get",
    headers,
  });
}

// 获取用户端消息已读未读数量
export function unReadNum(headers) {
  return request({
    url: "/userNoticeRecord/unReadNum",
    method: "get",
    headers,
  });
}

// 获取供应商未读消息数量
export function supplierunReadNum(headers) {
  return request({
    url: "/supplierNoticeRecord/unReadNum",
    method: "get",
    headers,
  });
}


// 获取供应商端工作台基础数据
export function workbenches(params,headers) {
  return request({
    url: "/supplier/workbenches",
    method: "get",
    params,
    headers,
  });
}

// 获取有效  航线
export function routeValidList(params) {
  return request({
    url: "/destinationPortRoute/validRouteList",
    method: "get",
    params,
  });
}

// 根据航线获取目的港
export function routePortValidList(params) {
  return request({
    url: "/destinationPortRoute/validPortList",
    method: "get",
    params,
  });
}

// 获取有效  起运港  数据列表
export function basePortValidList(params) {
  return request({
    url: "/basePort/validList",
    method: "get",
    params,
  });
}

// 获取有效  船公司  数据列表
export function baseShippingCompanyValidList() {
  return request({
    url: "/baseShippingCompany/validList",
    method: "get",
  });
}

// 获取有效  箱规  数据列表
export function baseCasesGaugeTypeValidList(params) {
  return request({
    url: "/baseCasesGaugeType/validList",
    method: "get",
    params,
  });
}

// 获取有效  目的港港口  数据列表
export function destinationPortRouteTypeValidList(params) {
  return request({
    url: "/destinationPortRoute/validList",
    method: "get",
    params,
  });
}

// 会员套餐列表
export function vipLists(params,headers) {
  return request({
    url: "/vipItem/validList",
    method: "get",
    params,
    headers: headers,
  });
}

// 会员权益对应关系列表
export function vipItemRights(params,headers) {
  return request({
    url: "/vipItem/vipItemRights",
    method: "get",
    params,
    headers: headers,
  });
}

// 供应商会员发布次数
export function supplierOnlineNum(params,headers) {
  return request({
    url: "/supplierVip/onlineNum",
    method: "get",
    params,
    headers: headers,
  });
}


// 箱型亏舱费
export function getDeadFreight(params,headers) {
  return request({
    url: "/dict/getDeadFreight",
    method: "get",
    params,
    headers: headers,
  });
}

// 字典数据列表
export function dict(params,headers) {
  return request({
    url: "/dict/dict",
    method: "get",
    params,
    headers: headers,
  });
}

// 码头箱动态
export function validList(params,headers) {
  return request({
    url: "/basePortContainerDynamics/validList",
    method: "get",
    params,
    headers: headers,
  });
}


// 码头箱动态
export function currentCabinValidList(params,headers) {
  return request({
    url: "/SeaFclFreight/currentCabinValidList",
    method: "get",
    params,
    headers: headers,
  });
}

// 首页精选运价列表
export function homeCherryPickList(params,headers) {
  return request({
    url: "/SeaFclFreight/cherryPickValidList",
    method: "get",
    params,
    headers: headers,
  });
}

// 邀请好友
export function buyVipLists(params,headers) {
  return request({
    url: "/userInvite/buyVipLists",
    method: "get",
    params,
    headers,
  });
}

// 用户购买会员记录
export function userInviteLists(params,headers) {
  return request({
    url: "/userInvite/userInviteLists",
    method: "get",
    params,
    headers,
  });
}
// ------------------------------------------------------------ 美加到门  基础数据 ------------------------------------------------------------
// 国家数据
export function getMjdmCountries() {
  return request({
    url: "/mjdmBase/getMjdmCountries",
    method: "get",
  });
}

// 根据国家获取港口列表   起运港
export function getPortByCountries(params) {
  return request({
    url: "/mjdmBase/getPortByCountries",
    method: "get",
    params,
  });
}

// 获取城市列表  城市邮编
export function getCityList(params) {
  return request({
    url: "/mjdmBase/getCityList",
    method: "get",
    params,
  });
}

// 根据城市id获取港口列表  卸货地卸货港
export function getPortByCityId(params) {
  return request({
    url: "/mjdmBase/getPortByCityId",
    method: "get",
    params,
  });
}

// 在线询价
export function MjdmOnlineInquiryRecordsAdd(data,headers) {
  return request({
    url: "/mjdmOnlineInquiryRecords/addRecord",
    method: "post",
    data,
    headers,
  });
}

// 在线询价列表
export function mjdmmyRecordsLists(params,headers) {
  return request({
    url: "/mjdmOnlineInquiryRecords/myRecordsLists",
    method: "get",
    params,
    headers,
  });
}

// 在线询价下单
export function MjdmOnlineInquiryRecordsAddOrder(data,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrders/addOrder",
    method: "post",
    data,
    headers,
  });
}

// 询价订单列表
export function myOrdersLists(params,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrders/myOrdersLists",
    method: "get",
    params,
    headers,
  });
}

// 询价订单详情
export function myOrdersDetail(params,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrders/myOrdersDetail",
    method: "get",
    params,
    headers,
  });
}

// 确认账单
export function billStatus(data,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrders/billStatus",
    method: "post",
    data,
    headers,
  });
}

// 美加取消订单 mjCancelOrder  shipCancelOrder jxCancelOrder
export function mjCancelOrder(data,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrders/cancelOrder",
    method: "post",
    data,
    headers,
  });
}

// 询价订单  模版列表
export function mjdmTemplateLists(params,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/lists",
    method: "get",
    params,
    headers,
  });
}

// 模版添加
export function mjdmTemplateAdd(data,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/add",
    method: "post",
    data,
    headers,
  });
}

// 模版编辑
export function mjdmTemplateEdit(data,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/edit",
    method: "post",
    data,
    headers,
  });
}

// 模版删除
export function mjdmTemplateDel(data,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/delete",
    method: "post",
    data,
    headers,
  });
}

// 模版详情
export function mjdmTemplateDetail(params,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/detail",
    method: "get",
    params,
    headers,
  });
}


// 是否禁用
export function mjdmTemplateDisable(data,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/editDisable",
    method: "post",
    data,
    headers,
  });
}

// 有效模版
export function mjdmTemplateAalidList(params,headers) {
  return request({
    url: "/mjdmOnlineInquiryOrdersTemplate/validList",
    method: "get",
    params,
    headers,
  });
}

// 留言列表
export function mjdmLiuyanLists(params,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrdersLiuyan/liuyanLists",
    method: "get",
    params,
    headers,
  });
}

// 添加新留言
export function mjdmAddLiuyan(data,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrdersLiuyan/addLiuyan",
    method: "post",
    data,
    headers,
  });
}

// 导出账单详情
export function mjdmCreateOrderInfo(data,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrders/createOrderInfo",
    method: "post",
    data,
    headers,
  });
}

// 导出账单明细
export function mjdmExportBill(data,headers) {
  return request({
    url: "/MjdmOnlineInquiryOrders/exportBill",
    method: "post",
    data,
    headers,
  });
}

// ------------------------------------------------------------ 政策协议 ------------------------------------------------------------
export function indexPolicy(params) {
  return request({
    url: "/index/policy",
    method: "get",
    params,
    // ?type=service
  });
}


// ------------------------------------------------------------ 发送邮件 ------------------------------------------------------------
// 发送邮箱验证码
export function emailSendCode(data,headers) {
  return request({
    url: "/email/sendCode",
    method: "post",
    data,
    headers:headers
  });
}

// ------------------------------------------------------------ 上传管理 ------------------------------------------------------------
// ------------------------------------------------------------ 登录注册 ------------------------------------------------------------
// 扫码登录 
export function getQrCode(data) {
  return request({
    url: "/login/getQrCode",
    method: "post",
    data,
  });
}


// 检测是否扫码 
export function checkScanLoginQrcodeStatus(params) {
  return request({
    url: "/login/checkScanLoginQrcodeStatus",
    method: "get",
    params,
  });
}


// 用户登录 
export function loginAccount(data) {
  return request({
    url: "/login/account",
    method: "post",
    data,
  });
}

// 用户登录忘记密码 
export function userResetPassword(data) {
  return request({
    url: "/user/resetPassword",
    method: "post",
    data,
  });
}

// 发送短信验证码
export function smsSendCode(data) {
  return request({
    url: "/sms/sendCode",
    method: "post",
    data,
  });
}

// 根据条件搜索用户信息
export function searchUser(params,headers) {
  return request({
    url: "/user/searchUser",
    method: "get",
    params,
    headers:headers
  });
}

// ------------------------------------------------------------ 用户模块 ------------------------------------------------------------
// ------------------用户信息
// 获取个人信息
export function userCenter(headers) {
  return request({
    url: "/user/center",
    method: "get",
    headers: headers,
  });
}

// 设置、修改密码
export function changePassword(data,headers) {
  return request({
    url: "/user/changePassword",
    method: "post",
    data,
    headers: headers,
  });
}

// 更换手机号
export function bindMobile(data,headers) {
  return request({
    url: "/user/bindMobile",
    method: "post",
    data,
    headers: headers,
  });
}

// 设置信息
export function setInfo(data,headers) {
  return request({
    url: "/user/setInfo",
    method: "post",
    data,
    headers: headers,
  });
}

// 获取用户认证信息
export function userAuthenticationInfo(headers) {
  return request({
    url: "/userAuthentication/info",
    method: "get",
    headers: headers,
  });
}

// 编辑用户认证信息
export function userAuthenticationEdit(data,headers) {
  return request({
    url: "/userAuthentication/edit",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------我的钱包
// 获取充值余额列表
export function getRechargeAmountList(headers) {
  return request({
    url: "/recharge/getRechargeAmountList",
    method: "get",
    // params,
    headers: headers,
  });
}

// 用户 获取微信支付二维码
export function getPayQRCode(data,headers) {
  return request({
    url: "/recharge/getPayQRCode",
    method: "post",
    data,
    headers: headers,
  });
}

// 供应商 获取微信支付二维码
export function getsupplierPayQRCode(data,headers) {
  return request({
    url: "/supplierRecharge/getPayQRCode",
    method: "post",
    data,
    headers: headers,
  });
}

// 获取充值配置
export function rechargeConfig(headers) {
  return request({
    url: "/recharge/config",
    method: "get",
    // params,
    headers: headers,
  });
}

// 余额充值
export function recharge(data,headers) {
  return request({
    url: "/recharge/recharge",
    method: "post",
    data,
    headers: headers,
  });
}

// 申请提现
export function withdrawal(data,headers) {
  return request({
    url: "/withdrawal/withdrawal",
    method: "post",
    data,
    headers: headers,
  });
}

// 流水明细列表
export function accountLogLists(params,headers) {
  return request({
    url: "/accountLog/lists",
    method: "get",
    params,
    headers: headers,
  });
}


// 流水明细详情
export function accountLogDetails(params,headers) {
  return request({
    url: "/accountLog/details",
    method: "get",
    params,
    headers: headers,
  });
}


// 订单发票列表
export function orderFapiaolists(params,headers) {
  return request({
    url: "/accountLog/orderFapiaolists",
    method: "get",
    params,
    headers: headers,
  });
}


// 订单发票详情
export function orderFapiaoDetails(params,headers) {
  return request({
    url: "/accountLog/orderFapiaoDetails",
    method: "get",
    params,
    headers: headers,
  });
}


// 申请开票
export function applyFapiao(data,headers) {
  return request({
    url: "/accountLog/applyFapiao",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------开通会员
// 开通会员
export function openVip(data,headers) {
  return request({
    url: "/userVip/openVip",
    method: "post",
    data,
    headers: headers,
  });
}

// 会员明细列表
export function useVipList(params,headers) {
  return request({
    url: "/userVip/useVipList",
    method: "get",
    params,
    headers: headers,
  });
}

// 兑换码列表
// 用户VIP绑定列表
export function useVipRedemptionCodeList(params,headers) {
  return request({
    url: "/userVip/useVipRedemptionCodeList",
    method: "get",
    params,
    headers: headers,
  });
}

// 兑换码兑换会员身份
// 绑定新用户
export function redemption(data,headers) {
  return request({
    url: "/userVip/redemption",
    method: "post",
    data,
    headers: headers,
  });
}

// 用户删除绑定用户
export function userdeleteBindUserVip(data,headers) {
  return request({
    url: "/userVip/deleteBindUserVip",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------模版中心
// 列表
export function userTemplateLists(params,headers) {
  return request({
    url: "/userTemplate/lists",
    method: "get",
    params,
    headers: headers,
  });
}

// 列表详情
export function userTemplateDetail(params,headers) {
  return request({
    url: "/userTemplate/detail",
    method: "get",
    params,
    headers: headers,
  });
}

// 添加
export function userTemplateAdd(data,headers) {
  return request({
    url: "/userTemplate/add",
    method: "post",
    data,
    headers: headers,
  });
}

// 编辑
export function userTemplateEdit(data,headers) {
  return request({
    url: "/userTemplate/edit",
    method: "post",
    data,
    headers: headers,
  });
}

// 删除
export function userTemplateDelete(data,headers) {
  return request({
    url: "/userTemplate/delete",
    method: "post",
    data,
    headers: headers,
  });
}

// 修改状态
export function userTemplateOnline(data,headers) {
  return request({
    url: "/userTemplate/editDisable",
    method: "post",
    data,
    headers: headers,
  });
}

// 我的模版列表  获取有效模版
export function userTemplateValidList(params,headers) {
  return request({
    url: "/userTemplate/validList",
    method: "get",
    params,
    headers: headers,
  });
}

// ------------------------------------------------------------ ----------------   工作台供应商后台   -------------------------------------- ------------------------------------------------------------
// ------------------------------------------------------------ 供应商模块 ------------------------------------------------------------

export function supplierInfo(params,headers){
  return request({
    url:'/supplier/info',
    method:'get',
    params,
    headers:headers
  })
 }

export function supplierEdit(data,headers){
  return request({
    url:'/supplier/edit',
    method:'post',
    data,
    headers:headers
  })
 }

// ------------------------------------------------------------ 我的钱包 ------------------------------------------------------------
// 获取供应商钱包数据
export function supplierPocketbook(params,headers) {
  return request({
    url: "/supplier/pocketbook",
    method: "get",
    params,
    headers: headers,
  });
}

// 获取充值余额列表
export function supplierrechargeGetRechargeAmountList(headers) {
  return request({
    url: "/supplierRecharge/getRechargeAmountList",
    method: "get",
    // params,
    headers: headers,
  });
}

// 获取充值配置
export function supplierRechargeConfig(headers) {
  return request({
    url: "/supplierRecharge/config",
    method: "get",
    // params,
    headers: headers,
  });
}

// 余额充值
export function supplierRecharge(data,headers) {
  return request({
    url: "/supplierRecharge/recharge",
    method: "post",
    data,
    headers: headers,
  });
}

// 申请提现
export function supplierWithdrawal(data,headers) {
  return request({
    url: "/withdrawal/supplierWithdrawal",
    method: "post",
    data,
    headers: headers,
  });
}

// 流水明细列表
export function supplierAccountLogLists(params,headers) {
  return request({
    url: "/supplierAccountLog/lists",
    method: "get",
    params,
    headers: headers,
  });
}


// 流水明细详情
export function supplierAccountDetails(params,headers) {
  return request({
    url: "/supplierAccountLog/details",
    method: "get",
    params,
    headers: headers,
  });
}

// 订单发票列表
export function supplierOrderFapiaolists(params,headers) {
  return request({
    url: "/supplierAccountLog/orderFapiaolists",
    method: "get",
    params,
    headers: headers,
  });
}


// 订单发票详情
export function supplierOrderFapiaoDetails(params,headers) {
  return request({
    url: "/supplierAccountLog/orderFapiaoDetails",
    method: "get",
    params,
    headers: headers,
  });
}


// 申请开票
export function supplierApplyFapiao(data,headers) {
  return request({
    url: "/supplierAccountLog/applyFapiao",
    method: "post",
    data,
    headers: headers,
  });
}

// 冻结亏舱费列表
export function supplierDeadFreightLists(params,headers) {
  return request({
    url: "/supplierAccountLog/deadFreightLists",
    method: "get",
    params,
    headers: headers,
  });
}


// 申请亏舱费金额解冻
export function supplierApplyThawDeadFreight(data,headers) {
  return request({
    url: "/supplierAccountLog/applyThawDeadFreight",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------开通会员
// 开通会员
export function supplierOpenVip(data,headers) {
  return request({
    url: "/supplier/openVip",
    method: "post",
    data,
    headers: headers,
  });
}

// 会员购买记录
export function supplierVipList(params,headers) {
  return request({
    url: "/supplierVip/supplierVipList",
    method: "get",
    params,
    headers: headers,
  });
}

// 会员绑定用户列表
export function supplierVipRedemptionCodeList(headers) {
  return request({
    url: "/supplierVip/supplierVipRedemptionCodeList",
    method: "get",
    headers: headers,
  });
}

// 添加绑定用户
export function addBindUserVip(data,headers) {
  return request({
    url: "/supplierVip/addBindUserVip",
    method: "post",
    data,
    headers: headers,
  });
}

// 供应商删除绑定用户
export function deleteBindUserVip(data,headers) {
  return request({
    url: "/supplierVip/deleteBindUserVip",
    method: "post",
    data,
    headers: headers,
  });
}



// ----------------------子账号
// 列表
export function subAccountLists(params,headers) {
  return request({
    url: "/supplier/subAccountLists",
    method: "get",
    params,
    headers: headers,
  });
}

// 添加
export function subAccountAdd(data,headers) {
  return request({
    url: "/supplier/subAccountAdd",
    method: "post",
    data,
    headers: headers,
  });
}

// 删除
export function subAccountDelete(data,headers) {
  return request({
    url: "/supplier/subAccountDelete",
    method: "post",
    data,
    headers: headers,
  });
}

// 修改
export function subAccountEdit(data,headers) {
  return request({
    url: "/supplier/subAccountEdit",
    method: "post",
    data,
    headers: headers,
  });
}

// 修改状态
export function subAccountDisable(data,headers) {
  return request({
    url: "/supplier/subAccountDisable",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------舱位管理
// 列表
export function shippingSpaceLists(params,headers) {
  return request({
    url: "/shippingSpace/lists",
    method: "get",
    params,
    headers: headers,
  });
}

// 列表详情
export function shippingSpaceDetail(params,headers) {
  return request({
    url: "/shippingSpace/detail",
    method: "get",
    params,
    headers: headers,
  });
}

// 批量发布
export function shippingSpaceBatch(data,headers) {
  return request({
    url: "/shippingSpace/batchRelease",
    method: "post",
    data,
    headers: headers,
  });
}

// 一键下架
export function oneClickRemoval(data,headers) {
  return request({
    url: "/shippingSpace/oneClickRemoval",
    method: "post",
    data,
    headers: headers,
  });
}


// 一键删除
export function oneClickDelete(data,headers) {
  return request({
    url: "/shippingSpace/oneClickDelete",
    method: "post",
    data,
    headers: headers,
  });
}



// 添加
export function shippingSpaceAdd(data,headers) {
  return request({
    url: "/shippingSpace/add",
    method: "post",
    data,
    headers: headers,
  });
}

// 编辑
export function shippingSpaceEdit(data,headers) {
  return request({
    url: "/shippingSpace/edit",
    method: "post",
    data,
    headers: headers,
  });
}

// 删除
export function shippingSpaceDelete(data,headers) {
  return request({
    url: "/shippingSpace/delete",
    method: "post",
    data,
    headers: headers,
  });
}

// 修改上下架状态
export function shippingSpaceOnline(data,headers) {
  return request({
    url: "/shippingSpace/online",
    method: "post",
    data,
    headers: headers,
  });
}

// 申诉
export function onlineAppeal(data,headers) {
  return request({
    url: "/shippingSpace/onlineAppeal",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------运费模板
// 列表
export function supplierTemplateLists(params,headers) {
  return request({
    url: "/supplierTemplate/lists",
    method: "get",
    params,
    headers: headers,
  });
}

// 列表详情
export function supplierTemplateDetail(params,headers) {
  return request({
    url: "/supplierTemplate/detail",
    method: "get",
    params,
    headers: headers,
  });
}

// 添加
export function supplierTemplateAdd(data,headers) {
  return request({
    url: "/supplierTemplate/add",
    method: "post",
    data,
    headers: headers,
  });
}

// 编辑
export function supplierTemplateEdit(data,headers) {
  return request({
    url: "/supplierTemplate/edit",
    method: "post",
    data,
    headers: headers,
  });
}

// 删除
export function supplierTemplateDelete(data,headers) {
  return request({
    url: "/supplierTemplate/delete",
    method: "post",
    data,
    headers: headers,
  });
}

// 修改状态
export function supplierTemplateOnline(data,headers) {
  return request({
    url: "/supplierTemplate/editDisable",
    method: "post",
    data,
    headers: headers,
  });
}

// 根据条件搜索模版
export function supplierTemplateSearch(params,headers) {
  return request({
    url: "/supplierTemplate/search",
    method: "get",
    params,
    headers: headers,
  });
}


// 批量发布模版列表 
export function supplierTemplateListsQuick(params,headers) {
  return request({
    url: "/shippingSpaceQuickTemplate/lists",
    method: "get",
    params,
    headers: headers,
  });
}

// 批量发布模版列表 详情
export function supplierTemplateDetailQuick(params,headers) {
  return request({
    url: "/shippingSpaceQuickTemplate/detail",
    method: "get",
    params,
    headers: headers,
  });
}

// 批量发布模版列表 添加
export function supplierTemplateAddQuick(data,headers) {
  return request({
    url: "/shippingSpaceQuickTemplate/add",
    method: "post",
    data,
    headers: headers,
  });
}

// 批量发布模版列表 编辑
export function supplierTemplateEditQuick(data,headers) {
  return request({
    url: "/shippingSpaceQuickTemplate/edit",
    method: "post",
    data,
    headers: headers,
  });
}

// 批量发布模版列表 删除
export function supplierTemplateDeleteQuick(data,headers) {
  return request({
    url: "/shippingSpaceQuickTemplate/delete",
    method: "post",
    data,
    headers: headers,
  });
}

// 批量发布模版列表 有效模版
export function supplierTemplateValidQuick(params,headers) {
  return request({
    url: "/shippingSpaceQuickTemplate/validLists",
    method: "get",
    params,
    headers: headers,
  });
}
// ----------------------- 操作日志
// 列表
export function userOperationLog(params,headers) {
  return request({
    url: "/userOperationLog/lists",
    method: "get",
    params,
    headers: headers,
  });
}



// ----------------------------- 订舱
// 客服列表
export function getBaseEmailsByPolId(params,headers) {
  return request({
    url: "/SeaFclFreight/getBaseEmailsByPolId",
    method: "get",
    params,
    headers: headers,
  });
}

// 收发通  有历史记录
export function getHistorySftInfoList(headers) {
  return request({
    url: "/SeaFclFreight/getHistorySftInfoList",
    method: "get",
    headers: headers,
  });
}

// 联系人  历史记录
export function getHistoryLinkmanInfoList(headers) {
  return request({
    url: "/SeaFclFreight/getHistoryLinkmanInfoList",
    method: "get",
    headers: headers,
  });
}

// 精选运价查询
export function cherryPickSelect(data,headers) {
  return request({
    url: "/SeaFclFreight/cherryPickSelect",
    method: "post",
    data,
    headers: headers,
  });
}

// 现舱市场查询
export function currentCabinSelect(data,headers) {
  return request({
    url: "/SeaFclFreight/currentCabinSelect",
    method: "post",
    data,
    headers: headers,
  });
}

// 精选运价订舱
export function cherryPickOrder(data,headers) {
  return request({
    url: "/SeaFclFreight/cherryPickOrder",
    method: "post",
    data,
    headers: headers,
  });
}


// 现舱市场订舱
export function currentCabinOrder(data,headers) {
  return request({
    url: "/SeaFclFreight/currentCabinOrder",
    method: "post",
    data,
    headers: headers,
  });
}


// 船东查询
export function getSpotrateList(data,headers) {
  return request({
    url: "/shipownerSpot/getSpotrateList",
    method: "post",
    data,
    headers: headers,
  });
}


// 船东订舱
export function spotOrder(data,headers) {
  return request({
    url: "/shipownerSpot/spotOrder",
    method: "post",
    data,
    headers: headers,
  });
}

// 船东获取保障金
export function config(headers) {
  return request({
    url: "/dict/config",
    method: "get",
    headers: headers,
  });
}


// 船东列表
export function shipOrderList(params,headers) {
  return request({
    url: "/shipownerSpot/myOrderList",
    method: "get",
    params,
    headers: headers,
  });
}

// 详情
export function shipOrderDetail(params,headers) {
  return request({
    url: "/shipownerSpot/myOrderDetail",
    method: "get",
    params,
    headers: headers,
  });
}

// 船东取消订单
export function shipCancelOrder(data,headers) {
  return request({
    url: "/shipownerSpot/cancelOrder",
    method: "post",
    data,
    headers: headers,
  });
}

// 船期查询
export function getScheduleList(data,headers) {
  return request({
    url: "/shipownerSpot/getScheduleList",
    method: "post",
    data,
    headers: headers,
  });
}

// 舱位确认
export function askAboutShippingSpace(data,headers) {
  return request({
    url: "/SeaFclFreight/askAboutShippingSpace",
    method: "post",
    data,
    headers: headers,
  });
}

// ----------------------------- 船司账号
export function shippingAccountList(params,headers) {
  return request({
    url: "/userShippingCompanyAccount/lists",
    method: "get",
    params,
    headers: headers,
  });
}

export function shippingAccountAdd(data,headers) {
  return request({
    url: "/userShippingCompanyAccount/add",
    method: "post",
    data,
    headers: headers,
  });
}

export function shippingAccountEdit(data,headers) {
  return request({
    url: "/userShippingCompanyAccount/edit",
    method: "post",
    data,
    headers: headers,
  });
}

export function shippingAccountDelete(data,headers) {
  return request({
    url: "/userShippingCompanyAccount/delete",
    method: "post",
    data,
    headers: headers,
  });
}


export function shippingAccountDetail(params,headers) {
  return request({
    url: "/userShippingCompanyAccount/detail",
    method: "get",
    params,
    headers: headers,
  });
}

// 修改禁用状态
export function shippingAccountDisable(data,headers) {
  return request({
    url: "/userShippingCompanyAccount/disable",
    method: "post",
    data,
    headers: headers,
  });
}

// 修改默认状态
export function shippingAccountDefault(data,headers) {
  return request({
    url: "/userShippingCompanyAccount/default",
    method: "post",
    data,
    headers: headers,
  });
}

// 下载导入模版
export function shippingAccountDownload(headers) {
  return request({
    url: "/userShippingCompanyAccount/download",
    method: "post",
    headers: headers,
  });
}

// 导入账号
export function shippingAccountImport(data,headers) {
  return request({
    url: "/userShippingCompanyAccount/import",
    method: "get",
    data,
    headers: headers,
  });
}

// ----------------------------- 查询历史记录
// 查询记录
export function myRecordsLists(params,headers) {
  return request({
    url: "/userInquiryRecords/myRecordsLists",
    method: "get",
    params,
    headers: headers,
  });
}

// 历史港口
export function historyPort(headers) {
  return request({
    url: "/userInquiryRecords/historyPort",
    method: "get",
    headers: headers,
  });
}


// ----------------------------- 盯舱宝
// 列表数据
export function staringAtLists(params,headers) {
  return request({
    url: "/userStaringAtTheCabin/lists",
    method: "get",
    params,
    headers,
  });
}

// 增
export function staringAtAdd(data,headers) {
  return request({
    url: "/userStaringAtTheCabin/add",
    method: "post",
    data,
    headers,
  });
}

// 改
export function staringAtEdit(data,headers) {
  return request({
    url: "/userStaringAtTheCabin/edit",
    method: "post",
    data,
    headers,
  });
}

// 删
export function staringAtDelete(data,headers) {
  return request({
    url: "/userStaringAtTheCabin/delete",
    method: "post",
    data,
    headers,
  });
}

// 详情
export function staringAtDetail(params,headers) {
  return request({
    url: "/userStaringAtTheCabin/detail",
    method: "get",
    params,
    headers,
  });
}

// ----------------------------- 我的订单
// 精选运价  现舱市场  取消订单
export function jxCancelOrder(data,headers) {
  return request({
    url: "/userOrderBookingSpace/cancelOrder",
    method: "post",
    data,
    headers: headers,
  });
}

// 列表数据
export function myOrderList(params,headers) {
  return request({
    url: "/userOrderBookingSpace/myOrderList",
    method: "get",
    params,
    headers,
  });
}

// 列表详情
export function myOrderDetail(params,headers) {
  return request({
    url: "/userOrderBookingSpace/myOrderDetail",
    method: "get",
    params,
    headers,
  });
}

// 留言列表
export function userliuyanLists(params,headers) {
  return request({
    url: "/userOrderBookingSpace/liuyanLists",
    method: "get",
    params,
    headers,
  });
}

// 留言
export function useraddLiuyan(data,headers) {
  return request({
    url: "/userOrderBookingSpace/addLiuyan",
    method: "post",
    data,
    headers,
  });
}


// 账单变动记录列表
export function billChangeLists(params,headers) {
  return request({
    url: "/userOrderBookingSpace/billChangeLists",
    method: "get",
    params,
    headers,
  });
}


// 审核订单账单
export function checkBillChange(data,headers) {
  return request({
    url: "/userOrderBookingSpace/checkBillChange",
    method: "post",
    data,
    headers,
  });
}

// 生成订舱确认书
export function createBookingNote(data,headers) {
  return request({
    url: "/userOrderBookingSpace/createBookingNote",
    method: "post",
    data,
    headers,
  });
}

// 生成截单确认书
export function createCutOffConfirmation(data,headers) {
  return request({
    url: "/userOrderBookingSpace/createCutOffConfirmation",
    method: "post",
    data,
    headers,
  });
}

// 导出订单详情
export function createOrderInfo(data,headers) {
  return request({
    url: "/userOrderBookingSpace/createOrderInfo",
    method: "post",
    data,
    headers,
  });
}

// 导出账单明细
export function exportBill(data,headers) {
  return request({
    url: "/userOrderBookingSpace/exportBill",
    method: "post",
    data,
    headers,
  });
}


// ----------------------------- 供应商端 我的订单
// 列表数据
export function supplierBillLis(params,headers) {
  return request({
    url: "/supplierOrderBookingSpace/billList",
    method: "get",
    params,
    headers,
  });
}


// 列表数据
export function supplierMyOrderList(params,headers) {
  return request({
    url: "/supplierOrderBookingSpace/myOrderList",
    method: "get",
    params,
    headers,
  });
}

// 列表详情
export function supplierMyOrderDetail(params,headers) {
  return request({
    url: "/supplierOrderBookingSpace/myOrderDetail",
    method: "get",
    params,
    headers,
  });
}

// 留言列表
export function supplierUserliuyanLists(params,headers) {
  return request({
    url: "/supplierOrderBookingSpace/liuyanLists",
    method: "get",
    params,
    headers,
  });
}

// 留言
export function supplierUseraddLiuyan(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/addLiuyan",
    method: "post",
    data,
    headers,
  });
}

// 账单变动记录列表
export function supplierBillChangeLists(params,headers) {
  return request({
    url: "/supplierOrderBookingSpace/billChangeLists",
    method: "get",
    params,
    headers,
  });
}


// 编辑订单账单
export function editSurcharge(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/editSurcharge",
    method: "post",
    data,
    headers,
  });
}

// 生成订舱确认书
export function supplierCreateBookingNote(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/createBookingNote",
    method: "post",
    data,
    headers,
  });
}

// 生成截单确认书
export function supplierCreateCutOffConfirmation(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/createCutOffConfirmation",
    method: "post",
    data,
    headers,
  });
}

// 导出订单详情
export function supplierCreateOrderInfo(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/createOrderInfo",
    method: "post",
    data,
    headers,
  });
}

// 导出账单明细
export function supplierExportBill(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/exportBill",
    method: "post",
    data,
    headers,
  });
}

// ----------------------------------------------------用户 订单 
// 确认订舱信息
export function confirmBookingInfo(data,headers) {
  return request({
    url: "/userOrderBookingSpace/confirmBookingInfo",
    method: "post",
    data,
    headers,
  });
}

// 确认截单信息
export function confirmCutOffInfo(data,headers) {
  return request({
    url: "/userOrderBookingSpace/confirmCutOffInfo",
    method: "post",
    data,
    headers,
  });
}

// 确认提单信息
export function confirmLadingBillInfo(data,headers) {
  return request({
    url: "/userOrderBookingSpace/confirmLadingBillInfo",
    method: "post",
    data,
    headers,
  });
}


// ----------------------------------------------------供应商 订单 
// 提交订舱信息
export function submitBookingInfo(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/submitBookingInfo",
    method: "post",
    data,
    headers,
  });
}

// 确认截单信息
export function supplierconfirmCutOffInfo(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/confirmCutOffInfo",
    method: "post",
    data,
    headers,
  });
}

// 提交提单信息
export function submitLadingBillInfo(data,headers) {
  return request({
    url: "/supplierOrderBookingSpace/submitLadingBillInfo",
    method: "post",
    data,
    headers,
  });
}


// ----------------------------------------------------用户 消息通知 
// 精选运价  美加发送邮件
export function sendEmail(data,headers) {
  return request({
    url: "/email/sendEmail",
    method: "post",
    data,
    headers,
  });
}

// 舱位留言  添加留言
export function shipReplyAdd(data,headers) {
  return request({
    url: "/shippingSpaceMessageRecord/addMessageRecord",
    method: "post",
    data,
    headers,
  });
}

// 舱位留言列表
export function cabinReplyList(params,headers) {
  return request({
    url: "/shippingSpaceMessageRecord/myMessageRecordLists",
    method: "get",
    params,
    headers,
  });
}
export function shipRecordDetail(params,headers) {
  return request({
    url: "/shippingSpaceMessageRecord/myMessageRecordDetail",
    method: "get",
    params,
    headers,
  });
}
export function shipRecordReplyLists(params,headers) {
  return request({
    url: "/shippingSpaceMessageRecord/messageRecordReplyLists",
    method: "get",
    params,
    headers,
  });
}
export function shipRecordReply(data,headers) {
  return request({
    url: "/shippingSpaceMessageRecord/replyMeaage",
    method: "post",
    data,
    headers,
  });
}

// 美加留言  添加留言
// 美加留言列表
export function mjdmReplyList(params,headers) {
  return request({
    url: "/mjdmMessageRecord/myMessageRecordLists",
    method: "get",
    params,
    headers,
  });
}
export function mjdmReplyAdd(data,headers) {
  return request({
    url: "/mjdmMessageRecord/addRecord",
    method: "post",
    data,
    headers,
  });
}
export function mjdmRecordDetail(params,headers) {
  return request({
    url: "/mjdmMessageRecord/myMessageRecordDetail",
    method: "get",
    params,
    headers,
  });
}
export function mjdmRecordReplyLists(params,headers) {
  return request({
    url: "/mjdmMessageRecord/messageRecordReplyLists",
    method: "get",
    params,
    headers,
  });
}
export function mjdmRecordReply(data,headers) {
  return request({
    url: "/mjdmMessageRecord/replyMeaage",
    method: "post",
    data,
    headers,
  });
}

// 消息通知列表
export function userNoticeLists(params,headers) {
  return request({
    url: "/userNoticeRecord/lists",
    method: "get",
    params,
    headers,
  });
}

// 消息通知详情
export function userNoticeDetail(params,headers) {
  return request({
    url: "/userNoticeRecord/detail",
    method: "get",
    params,
    headers,
  });
}

// ----------------------------------------------------供应商 消息通知 
// 消息通知列表
export function supplierNoticeLists(params,headers) {
  return request({
    url: "/supplierNoticeRecord/lists",
    method: "get",
    params,
    headers,
  });
}

// 一键已读
export function oneClickRead(data,headers) {
  return request({
    url: "/supplierNoticeRecord/oneClickRead",
    method: "post",
    data,
    headers,
  });
}

// 消息通知详情
export function supplierNoticeDetail(params,headers) {
  return request({
    url: "/supplierNoticeRecord/detail",
    method: "get",
    params,
    headers,
  });
}

// 回复舱位确认
export function replyShippingSpace(data,headers) {
  return request({
    url: "/supplierNoticeRecord/replyShippingSpace",
    method: "post",
    data,
    headers,
  });
}

// 代理商运价模版
export function svpPortLists(params,headers) {
  return request({
    url: "/svpFreightRate/getFreightRatePortLists",
    method: "get",
    params,
    headers,
  });
}

// 标记状态
export function svpMarkDisable(data,headers) {
  return request({
    url: "/svpFreightRate/supplierMarkDisable",
    method: "post",
    data,
    headers,
  });
}

// 收藏
export function svpCollect(data,headers) {
  return request({
    url: "/svpFreightRate/supplierCollect",
    method: "post",
    data,
    headers,
  });
}

// 今日发布数量
export function svpFreightRateCount(params,headers) {
  return request({
    url: "/svpFreightRate/svpPublishCount",
    method: "get",
    params,
    headers,
  });
}


// export function updateList(data){
//   return request({
//     url:'/info/update',
//     method:'put',
//     data:data
//   })
//  }
 
// export function deleList(id){
//   return request({
//     url:`/info/deleteList/${id}`,
//     method:'delete'
//   })
// }
 